(() => {
    class RemoveAllRolesModalController {

        constructor(
            $scope,
            $uibModalInstance,
            contextName,
            firstName,
            lastName,
            proceed
        ) {
            $scope.contextName = contextName;
            $scope.firstName = firstName;
            $scope.lastName = lastName;

            $scope.confirm = function () {
                $uibModalInstance.close(true);
                proceed();
            };

            $scope.cancel = function () {
                $uibModalInstance.close(false);
            };
        }

    }

    angular
        .module("dashboard")
        .controller("RemoveAllRolesModalController", [
            "$scope",
            "$uibModalInstance",
            "contextName",
            "firstName",
            "lastName",
            "proceed",
            RemoveAllRolesModalController
        ]);
})();
